import React from "react";

function Footer() {
  return (
    <div className="text-center p-6 bg-black footer">
      <span className="text-white">&copy; 2024 Copyright - </span>
      <a
        className="link-underline text-white font-bold"
        href="https://parthavchodvadiya.netlify.app"
      >
        Parthav Chodvadiya
      </a>
    </div>
  );
}

export default Footer;
